import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Content from './views/Content.vue';
//import Product from './views/Product.vue';
import Collection from './views/Collection.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Content,
    },
   /* {
      path: '/events',
      name: 'events',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" / './views/Events.vue'),
    },*/
    {
      path: '/(collection|kolekcja)/:url',
      name: 'content',
      component: Collection
    },
    {
      path: '/en/(collection|kolekcja)/:url',
      name: 'content',
      component: Collection
    },
    {
      path: '/products/:id',
      name: 'product',
      component: Content
    },
    {
      path: '/en/products/:id',
      name: 'product',
      component: Content
    },
    {
      path: '/:url',
      name: 'content',
      component: Content
    },
    {
      path: '/en/:url',
      name: 'content',
      component: Content
    },
  ],
});
